import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const imgBox = theme => css`
  width: ${rem(40)};
  height: ${rem(40)};
  flex-shrink: 0;
  background-color: ${theme.color.monochrome.light};
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.color.monochrome.mediumDark};

  img {
    width: 100%;
    height: 100%;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`

const link = css`
  svg {
    width: 16px;
    height: 16px;
    vertical-align: text-bottom;
  }
`

export const styles = { imgBox, link }
